import { normalizeLocale, type SupportedLocale } from './config';

function labels(
  close: string,
  minimize: string,
  maximize: string,
  restore: string,
  back: string,
  forward: string,
  sidebar: string,
  navigation: string
) {
  return {
    close,
    minimize,
    maximize,
    restore,
    back,
    forward,
    sidebar,
    navigation,
  };
}
const copy: Record<SupportedLocale, ReturnType<typeof labels>> = {
  en: labels(
    'Close window',
    'Minimize window',
    'Maximize window',
    'Restore window',
    'Go back',
    'Go forward',
    'Toggle sidebar',
    'Window navigation'
  ),
  ar: labels(
    'إغلاق النافذة',
    'تصغير النافذة',
    'تكبير النافذة',
    'استعادة النافذة',
    'رجوع',
    'تقدم',
    'تبديل الشريط الجانبي',
    'تنقل النافذة'
  ),
  es: labels(
    'Cerrar ventana',
    'Minimizar ventana',
    'Maximizar ventana',
    'Restaurar ventana',
    'Volver',
    'Avanzar',
    'Mostrar u ocultar barra lateral',
    'Navegación de la ventana'
  ),
  'pt-BR': labels(
    'Fechar janela',
    'Minimizar janela',
    'Maximizar janela',
    'Restaurar janela',
    'Voltar',
    'Avançar',
    'Mostrar ou ocultar barra lateral',
    'Navegação da janela'
  ),
  fr: labels(
    'Fermer la fenêtre',
    'Réduire la fenêtre',
    'Agrandir la fenêtre',
    'Restaurer la fenêtre',
    'Revenir',
    'Avancer',
    'Afficher ou masquer la barre latérale',
    'Navigation de la fenêtre'
  ),
  it: labels(
    'Chiudi finestra',
    'Riduci finestra',
    'Ingrandisci finestra',
    'Ripristina finestra',
    'Indietro',
    'Avanti',
    'Mostra o nascondi barra laterale',
    'Navigazione della finestra'
  ),
  ko: labels(
    '창 닫기',
    '창 최소화',
    '창 최대화',
    '창 복원',
    '뒤로',
    '앞으로',
    '사이드바 전환',
    '창 탐색'
  ),
  de: labels(
    'Fenster schließen',
    'Fenster minimieren',
    'Fenster maximieren',
    'Fenster wiederherstellen',
    'Zurück',
    'Vorwärts',
    'Seitenleiste ein- oder ausblenden',
    'Fensternavigation'
  ),
  ja: labels(
    'ウィンドウを閉じる',
    'ウィンドウを最小化',
    'ウィンドウを最大化',
    'ウィンドウを元に戻す',
    '戻る',
    '進む',
    'サイドバーを切り替える',
    'ウィンドウのナビゲーション'
  ),
  hi: labels(
    'विंडो बंद करें',
    'विंडो छोटी करें',
    'विंडो बड़ी करें',
    'विंडो पुनर्स्थापित करें',
    'पीछे जाएँ',
    'आगे जाएँ',
    'साइडबार दिखाएँ या छिपाएँ',
    'विंडो नेविगेशन'
  ),
  ru: labels(
    'Закрыть окно',
    'Свернуть окно',
    'Развернуть окно',
    'Восстановить окно',
    'Назад',
    'Вперёд',
    'Показать или скрыть боковую панель',
    'Навигация по окну'
  ),
  zh: labels(
    '关闭窗口',
    '最小化窗口',
    '最大化窗口',
    '还原窗口',
    '后退',
    '前进',
    '显示或隐藏侧边栏',
    '窗口导航'
  ),
  'zh-TW': labels(
    '關閉視窗',
    '最小化視窗',
    '最大化視窗',
    '還原視窗',
    '返回',
    '前進',
    '顯示或隱藏側邊欄',
    '視窗導覽'
  ),
  vi: labels(
    'Đóng cửa sổ',
    'Thu nhỏ cửa sổ',
    'Phóng to cửa sổ',
    'Khôi phục cửa sổ',
    'Quay lại',
    'Tiến tới',
    'Hiện hoặc ẩn thanh bên',
    'Điều hướng cửa sổ'
  ),
  id: labels(
    'Tutup jendela',
    'Minimalkan jendela',
    'Maksimalkan jendela',
    'Pulihkan jendela',
    'Kembali',
    'Maju',
    'Tampilkan atau sembunyikan bilah samping',
    'Navigasi jendela'
  ),
};
export function getDesktopWindowCopy(locale: string) {
  return copy[normalizeLocale(locale)];
}
